import React from 'react'
import CheckIcon from '@mui/icons-material/Check'

function Comfortable() {
  return (
    <div className='flex flex-col'>
      <div className='flex mb-3'>
        <CheckIcon sx={{ color: 'gray' }} />
        <p className='ml-2'>PHP | React Native | React Native Paper | NEXT</p>
      </div>
    </div>
  )
}

export default Comfortable
